import { EPaymentCardType } from '../../../../types/redux/paymentMethods';
import { EType } from '../../../../repositories/billing-payments/entities/PaymentWidget/WidgetLinkedCardResponse';
import { getIsEnumIncludes } from '../../../../utils/getIsEnumIncludes';

export const mapCardType = (type: EType | undefined): EPaymentCardType | null => {
  if (!type || !getIsEnumIncludes(EPaymentCardType, type)) {
    return null;
  }

  return type as string as EPaymentCardType;
};
